import cx from 'classnames';
import { format, parseISO } from 'date-fns';
import React from 'react';

import { getUserInitials } from 'utils';

import { PersonIcon } from './Icons';
import { ASSISTANT_TEXTS } from '../../texts';

import styles from './styles.module.css';

const EMPLOYMENT_TYPE_LABEL = { fullTime: 'Full time', partTime: 'Part time' };

const statusClassMap = {
	active: styles.statusActive,
	inactive: styles.statusInactive,
	leave: styles.statusPending,
};

const getStatusLabel = (status) => {
	if (status === 'active') return '● Active';
	if (status === 'leave') return '● On leave';
	return '● Inactive';
};

const formatDate = (iso) => {
	if (!iso) return '—';
	try {
		return format(parseISO(iso), 'd MMM yyyy');
	} catch {
		return iso;
	}
};

const deriveStatus = (crewMember) => {
	if (!crewMember.isActive) return 'inactive';
	return 'active';
};

const DriverResultCard = ({ crewMember }) => {
	const name = crewMember.fullName;
	const status = deriveStatus(crewMember);
	const homeCity = crewMember.currentHomeBase?.city?.name;
	const profilePath = `/crew-management/${crewMember.id}`;
	const statusClass = statusClassMap[status] ?? styles.statusPending;
	const statusLabel = getStatusLabel(status);

	const fields = [
		{ label: 'Driver card', value: crewMember.driverCard ?? '—' },
		{ label: 'Current run', value: crewMember.currentRun?.name ?? '—' },
		{ label: 'Home base', value: homeCity ?? '—' },
		{
			label: 'Employment',
			value: EMPLOYMENT_TYPE_LABEL[crewMember.currentEmploymentType?.employmentType] ?? '—',
		},
		{ label: 'License expires', value: formatDate(crewMember.driverLicenseExpiresAt) },
		{ label: 'Drug test expires', value: formatDate(crewMember.drugTestExpiresAt) },
		{ label: 'Medical expires', value: formatDate(crewMember.medicalCheckExpiresAt) },
		{ label: 'Phone', value: crewMember.phone ?? '—' },
	];

	return (
		<div className={styles.card}>
			<div className={styles.hero}>
				<div className={styles.avatar}>{getUserInitials(name)}</div>
				<div className={styles.heroInfo}>
					<div className={styles.driverName}>{name}</div>
					{homeCity && <div className={styles.driverMeta}>{homeCity}</div>}
				</div>
				<span className={cx(styles.statusBadge, statusClass)}>{statusLabel}</span>
			</div>

			<div className={styles.dataGrid}>
				{fields.map((f) => (
					<div key={f.label} className={styles.field}>
						<div className={styles.fieldLabel}>{f.label}</div>
						<div className={styles.fieldValue}>{f.value}</div>
					</div>
				))}
			</div>

			<div className={styles.actions}>
				<a className={styles.primaryBtn} href={profilePath}>
					<PersonIcon />
					{ASSISTANT_TEXTS.viewDriverProfile}
				</a>
			</div>
		</div>
	);
};

export default DriverResultCard;
